<template>
  <div class="student-answer-widget">
    <widgetTagsViewer
      v-if="
        (selectedQuestion &&
          selectedQuestion.question_type == 'multiple_choice') ||
        (selectedQuestion && selectedQuestion.question_type == 'checkboxes') ||
        (selectedQuestion && selectedQuestion.question_type == 'dropdown')
      "
      :tags="answerContent"
      :canDelete="false"
    ></widgetTagsViewer>
    <div
      v-else
      class="student-answer-widget-header"
      ref="dropdown_menu"
      @click="show = !show"
    >
      <div class="answer-left-content">
        {{ answerContent }}
      </div>
    </div>
    <div
      v-if="show"
      v-closable="{ exclude: ['dropdown_menu'], handler: 'hideMenu' }"
      class="student-answer-widget-body"
    >
      <div class="student-answer-widget-body-content">
        {{ answerContent }}
      </div>
      <div class="student-answer-widget-body-options">
        <button @click="show = false" class="btn-close">Close</button>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "",
  components: {},
  props: {
    selectedAnswer: {
      type: String,
      default: "",
    },
    allAnswer: {
      type: Array,
      default: () => [],
    },
    selectedQuestion: {
      type: Object,
      default: () => {},
    },
  },
  data: () => {
    return {
      show: false,
    };
  },
  mounted() {
    let vm = this;
  },
  computed: {
    answerContent() {
      let vm = this;
      if (vm.selectedAnswer && vm.selectedAnswer != "none") {
        return [{ name: vm.selectedAnswer }];
      } else {
        if (
          (vm.selectedQuestion &&
            vm.selectedQuestion.question_type == "multiple_choice") ||
          (vm.selectedQuestion &&
            vm.selectedQuestion.question_type == "checkboxes") ||
          (vm.selectedQuestion &&
            vm.selectedQuestion.question_type == "dropdown")
        ) {
          let ApprovedAnswer = [];
          vm.allAnswer.forEach((item) => {
            item.answer.forEach((answer) => {
              if (answer.ask == vm.selectedQuestion.ask) {
                answer.choice_options.forEach((option) => {
                  if (vm.selectedQuestion.question_type == "multiple_choice") {
                    if (option.value === answer.answer) {
                      ApprovedAnswer.push({ name: option.name });
                    }
                  } else {
                    if (option.value) {
                      ApprovedAnswer.push({ name: option.name });
                    }
                  }
                });
              }
            });
          });
          return ApprovedAnswer;
        } else {
          return vm.allAnswer[0].answer.find(
            (item) => item.ask == vm.selectedQuestion.ask
          ).answer;
        }
      }
    },
  },
  watch: {},
  methods: {
    hideMenu() {
      let vm = this;
      vm.show = false;
    },
  },
};
</script>
  <style lang="scss" scoped>
$assets: "~@/assets";
.student-answer-widget {
  display: flex;
  flex-direction: column;
  max-width: 200px;
  height: 100%;
  position: relative;
  .student-answer-widget-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    background: #ebebeb;
    border-radius: 5px;
    .answer-left-content {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      overflow: hidden;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 5px;
    }
  }
  .student-answer-widget-body {
    position: absolute;
    top: 30px;
    left: 0;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    z-index: 999;
    padding: 8px;
    border-radius: 5px;
    .student-answer-widget-body-content {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      padding: 0px 6px;
    }
    .student-answer-widget-body-options {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      padding: 6px 0px;
      .btn-close {
        width: max-content;
        height: 100%;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;
        color: rgba(8, 132, 175, 1);
      }
    }
  }
}
</style>
  
  
  